import React from 'react';
import PropTypes from 'prop-types';
import Routes from './routes';
import { BrowserRouter } from 'react-router-dom';
import NavigationServiceSetup from 'components/Shared/NavigationServiceSetup';
import { BlockerProvider } from './RouteCompat';

// React Router 7 no longer needs history prop - it manages its own history
// The basename is now passed directly to BrowserRouter
const baseName = (location.hostname === "localhost" || location.hostname === "dev-webui.mueller-inc.com") ? "/" : "/webui";

const App = ({persistor}) => (
  <BrowserRouter basename={baseName}>
    <BlockerProvider>
      <NavigationServiceSetup>
        <Routes {...{persistor}}/>
      </NavigationServiceSetup>
    </BlockerProvider>
  </BrowserRouter>
);   

App.propTypes = {
  persistor: PropTypes.object.isRequired, 
};

export default App;

